import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";

@ModuleName("ComplexPackageSelection")
export class ComplexPackageSelection implements AxInit {

    axLoading: AxLoading;
    private url: string;

    AxInit(init: any): void {
        this.axLoading = new AxLoading();
        this.url = init.url;

        this.setClickEvents();
    }

    setClickEvents() {
        $('.compPack_result_item').click((e) => {
            $('.compPack_result_item').each((i, obj) => {
                this.axLoading.HideLoadingIndicator(obj);
            });

            let body = $('.compPacks_selection_body')[0];

            this.axLoading.ShowLoadingIndicatorFixed(body);

            const packageId = $(e.currentTarget).attr('data-packageId');
            const tariffSheetId = $(e.currentTarget).attr('data-tariffSheetId');

            window.location.href = this.url + '?tariffSheetId=' + tariffSheetId + '&packageId=' + packageId;
        });
    }
}